module.exports = __webpack_public_path__ + "static/media/bgr-one-sm.0f07aaad.webp";